var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.add
      ? _c("div", { staticClass: "form-single" }, [
          _c("div", { staticClass: "title" }, [_vm._v("公告名称")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", [_vm._v(_vm._s(_vm.callBidNotice.title))])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title required" }, [_vm._v("上传附件")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "file-area clearfix" },
          _vm._l(_vm.enrollfile, function(file, index) {
            return _c("swb-file-item", {
              attrs: {
                trackKey: index,
                fileName: file.fileName,
                fileUuid: file.fileUuid,
                fileBrowseUrl: file.fileBrowseUrl,
                fileDownloadUrl: file.fileDownloadUrl,
                fileMd5: file.fileMd5
              }
            })
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-single" }, [
      _c("div", { staticClass: "title required" }, [_vm._v("内容信息")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("swb-ck-editor", {
            ref: "theCkEditor",
            attrs: {
              content: _vm.callBidNotice.content,
              imageXtHandler: _vm.imageXtHandler
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7eedc0f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eedc0f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/CallBidNoticeSave.vue
// module id = 1617
// module chunks = 1